import React from 'react';
import LeftNav from './../../common/leftnav/leftnav';
import HeaderTop from '../../common/headerTop/headerTop';
import $ from 'jquery';
import { ServerService as instanceService } from './../../../services/server.service';
import CommonMessage from './../../common/commonMessage';
import { SshkeyService } from '../../../services/sshkey.service';
import Distribution from './../../../statisjsondata/Distribution';
import ReactTooltip from 'react-tooltip';
import { distributionOption } from './createInstance.Constant';
import { getUnique, formatBytes, formatBytesFloat, getRandomPassword, formatBandwidthBytes, removeSpecialCharacter, dateInUTC } from '../../../utility/utility';
import { AuditLog } from './../../../services/auditlog.service';
import RegionService from '../../../services/region.service';
import DedicatedCpu from './dedicatedcpu';
import './../Region.css';
import { withStyles } from "@material-ui/styles";
import { ResourceService } from './../../../services/resource.service';
import Flavours from './../../../statisjsondata/Flavours';
import { Redirect } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import FlavorService from '../../../services/flavor.service';
import { axiosInstance, API_HOST, axiosRequestWithAuth } from '../../../constants/server.constant';
import i18n from '../../../i18n';
import { loginService } from '../../../services/login.service';
const styles = theme => ({
    overrideMe: {
        width: "800px",
        "word-break": "break-all",
        "overflow-wrap": "break-word",
        display: "block"
    }
});
class CloneInstance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            instanceForm: {
                region: '',
                regionCapcity: '',
                sshPublickey: '',
                sshName: '',
                sshKeys: [],
                isBackupEnabled: true,
                unitName: '',
                unit: 1,
                privateIp: false,
                userData: '',
                password: '',
                distName: '',
                version: '',
                instSet: '',
                name: '',
                ram: '',
                processor: '',
                storage: '',
                flavorRefId: '',
                imageRefId: '',
                flavorType: '',
                monthlyRate: '0',
                message: '',
                msgType: '',
                distrVersionName: '',
                isUserData: false
            },
            keyName: '',
            sshKeys: [],
            regionList: [],
            images: [],
            distributionImages: [],
            uniqueDistImages: [],
            distImagesMenu: [],
            instancePlans: [],
            dcpuList: [],
            instanceFilterPlans: [],
            sshPublickey: false,
            sshEmpty: false,
            sshKeyRegex: false,
            isUnitNameFocused: false,
            hidePwd: false,
            psswdStrength: 'Strong',
            isAction: false,
            errorMessg: '',
            selectedRegionUrl: '',
            computeRegionList: [],
            sshAuthorizedKeys: [],
            distributeDisplay: 'block',
            regionListFilter: [],
            regions: [],
            countryName: '',
            isScpu: true,
            dropRegion: '',
            regionErrorMsg: '',
            isCreateDisabled: true,
            isCreateExternalDisabled: !loginService.isInternalUser(),
            isUserSubscribed: false,
            isRedirectToCCPage: false,
            isLoginData: '#cloud-config\nruncmd:\n  - [\'sed\', \'-E\', \'-i\', \'s\/^[ #]*(PermitRootLogin|PasswordAuthentication|ChallengeResponseAuthentication) .*\/\\1 yes\/\', \'\/etc\/ssh\/sshd_config\']\n  - [\'systemctl\', \'restart\', \'sshd\']',
            eightCharLi: true,
            oneUpperLi: true,
            oneNumSpeLi: true,
            noNumSpeLi: true,
            isSshKey: true,
            isYearly: false,
            isPrepaidMonthly: true,
            discPerce: '',
            discVal: '',
            discCode: '',
            showSpeed: false,
            setLink: "",
            isBlocked: false,
            isNewContent: true,
            promocode: ''
        };
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.addUnit = this.addUnit.bind(this);
        this.removeUnit = this.removeUnit.bind(this);
        this.formChangeHandler = this.formChangeHandler.bind(this);
        this.cancel = this.cancel.bind(this);
        this.planBoxClick = this.planBoxClick.bind(this);
        this.planRadioClick = this.planRadioClick.bind(this);
        this.handlesubmit = this.handlesubmit.bind(this);
        this.scrollRef = React.createRef();
    }



    formChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if(name === 'unit') {
            val = parseInt(val.replace('Unit', '').replace(' ', '').trim());
            if(isNaN(val) || val === 0) {
                val = '';
            } else if(!Number.isInteger(val)) {
                val = 1;
            } else if(this.state.isScpu && val > 25) {
                val = 25;
            }
            else if(!this.state.isScpu && val > 10) {
                val = 10;
            }
            this.setUnitName(val);
        }
        let form = this.state.instanceForm;
        form[name] = val;
        if(name === 'password') {
            this.setState({ psswdStrength: getPsswdStrength(val), rootErrorMessg: '' });
            var middleCharPatt = new RegExp("[A-Z]");
            var str = val;
            var lastChar = str.charAt(str.length - 1);
            //At least 8 characters long
            if(val.length >= 8) {
                this.setState({
                    eightCharLi: true
                });
            } else {
                this.setState({
                    eightCharLi: false
                });
            }
            var str2 = str.slice(1, -1);
            //Must contain 1 uppercase (first and last characters don’t count)
            if(middleCharPatt.test(str2)) {
                this.setState({
                    oneUpperLi: true
                });
            } else {
                this.setState({
                    oneUpperLi: false
                });
            }
            //Must contain 1 number and 1 special character
            var patt2 = new RegExp("(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])");
            if(patt2.test(str)) {
                this.setState({
                    oneNumSpeLi: true
                });
            } else {
                this.setState({
                    oneNumSpeLi: false
                });
            }
            //Cannot end in a number or special character            
            var lastCharPatt = new RegExp("[A-Za-z]");
            if(lastCharPatt.test(lastChar)) {
                this.setState({
                    noNumSpeLi: true
                });
            } else {
                this.setState({
                    noNumSpeLi: false
                });
            }
        } else if(name === 'unitName') {
            if(val.length > 50) {
                return;
            }
            var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
            if(!nameRegex.test(val)) {
                this.setState({ unitNameErrorMessg: 'Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            } else {
                this.setState({ unitNameErrorMessg: '' });
            }
        } else if(name === 'unit') {
            this.setState({ unitErrorMessg: '' });
        }
        if(name === 'isLoginData') {
            if(val) {
                form.userData = form.userData + this.state.isLoginData;
            } else {
                form.userData = '';
            }
        }
        this.setState({ instanceForm: form, sshEmpty: false, sshKeyRegex: false, sshPublickeyEmpty: false, sshPublickeyError: false, sshNameError: false });
    };

    addUnit() {
        if(this.state.isYearly) {
            return;
        }
        let form = this.state.instanceForm;
        form.unit = ++form.unit;
        if(this.state.isScpu && form.unit > 25) {
            form.unit = 25;
        }
        else if(!this.state.isScpu && form.unit > 10) {
            form.unit = 10;
        }
        this.setUnitName(form.unit);
        this.setState({ instanceForm: form, unitErrorMessg: '' });
    }

    removeUnit() {
        if(this.state.isYearly) {
            return;
        }
        let unit = this.state.instanceForm.unit;
        if(unit === undefined || unit === '' || unit === 1) {
            return;
        }
        let form = this.state.instanceForm;
        form.unit = --form.unit;
        this.setUnitName(form.unit);
        this.setState({ instanceForm: form, unitErrorMessg: '' });
    }

    cancel = (event) => {
        $('.main_slider').removeClass('active');
        $('body').removeClass('no_scroll');
    };


    onRegionChange = (value) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        this.setState({ isAction: true, sshErrorMessg: '' });
        let val = value;
        let imageRegionUrl = this.getImageRegionUrl(val);
        let ComputeRegionUrl = this.getComputeRegionUrl(val);
        let locInstanceForm = this.state.instanceForm;
        locInstanceForm.region = val;
        locInstanceForm.unitName = '';
        locInstanceForm.ram = '';
        locInstanceForm.distName = '';
        locInstanceForm.distrVersionName = '';
        locInstanceForm.flavorRefId = '';
        locInstanceForm.imageRefId = '';
        locInstanceForm.distName = '';
        locInstanceForm.monthlyRate = '0';
        locInstanceForm.unit = 1;
        this.setImageDetailsByRegion(imageRegionUrl);
        this.checkRegionForSpeedLink(val);
        this.setFlavorDetailsByRegion(val);
        this.setSshKeyByRegion(ComputeRegionUrl);
        this.setState({ selectedRegionUrl: ComputeRegionUrl, instanceForm: locInstanceForm, keyName: '', sshAuthorizedKeys: [], isScpu: true, isYearly: false, isPrepaidMonthly: true });
        this.uncheckCheckBox();
    };

    uncheckCheckBox() {
        $(".checkremo").each(function () {
            $(this).prop("checked", false);
        });

        //for()
    }


    componentDidMount() {
        document.title = "IDrive® Compute | Clone Instance";
        if(!(this.props.location?.state?.instance || this.props.location?.state?.flavors)) {
            console.log(this.props.history);
            this.props.history.push({
                pathname: "/index",
                replace: true,
            });
            return;
        }
        window.scrollTo(0, 0);
        this.setDiscount();
        this.checkValidEmail();

        // $(".dataCenter_sec").focusout(function(e){
        //     $(".region_select_container").removeClass('active');
        //     //$('.regionSelect_options').removeClass('active')
        // });
    }

    setDiscount() {
        FlavorService.getDiscounts().then(resp => {
            if(Array.isArray(resp)) {
                let ob = resp[0];
                this.setState({ discCode: ob.code, discPerce: ob.discount, discVal: 100 / ob.discount });

            }
        });
        FlavorService.getMonthlyDiscounts('month').then(resp => {
            if(Array.isArray(resp)) {
                for(let i = 0; i < resp.length; i++) {
                    if(resp[i].code_type == "cloud") {
                        let ob = resp[i];
                        this.setState({ promocode: ob.code, discMonPerce: ob.discount, discMonVal: 100 / ob.discount });
                    }
                }
            }
        });
    }
    checkValidEmail = () => {
        let email = localStorage.getItem("email");
        this.setState({ isAction: true });
        axiosInstance.post(API_HOST + "/user/domainCheck/" + email, {}, axiosRequestWithAuth)
            .then(resp => {
                let res = resp.data;
                this.setState({
                    isBlocked: res === "NOT_BLOCKED" ? false : true
                });
                this.checkForSubscription();
            })
            .catch(error => {
                this.setState({ isAction: false });
            });
    };

    checkForSubscription = () => {
        this.setState({ isAction: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
                let form = this.state.instanceForm;
                form.password = getRandomPassword();

                this.setState({ instanceForm: form });
                this.loadRegionUserNotSubscribed();
            }
            else {
                let form = this.state.instanceForm;
                form.password = getRandomPassword();
                this.setState({ isAction: true, instanceForm: form });
                this.loadRegions();

            }

        });
    };
    loadRegionUserNotSubscribed() {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            if(resp && resp.length > 0) {
                let form = this.state.instanceForm;
                let elem = resp[0];
                form.region = elem.id;
                form.regionValue = elem.name;
                form.regionCapcity = elem.capacity;
                let sortedFlavours = this.sortPlanByAmount(Flavours);
                this.setState({
                    instancePlans: Flavours,
                    instanceFilterPlans: sortedFlavours.filter(filt => filt.type === 'SCPU'),
                    regions: resp,
                    distributionImages: Distribution,
                    uniqueDistImages: getUnique(Distribution, 'distribution'),
                    regions: resp,
                    isregionselected: true,
                    countryName: elem.countryName,
                    instanceForm: form
                });

            } else {
                this.setState({ isAction: false });
            }

        });
    }
    setRegionSelectState() {
        this.setState({ dropRegion: '', isregionselected: true });
    }

    setImageRegionDetails(selectedRegion) {
        instanceService.getRegionListByType('image').then(data1 => {
            let data = data1;
            if(data && data.length > 0) {
                let val = data.find(item => item.region === selectedRegion);
                this.setFlavorDetailsByRegion(val.region);
                this.setImageDetailsByRegion(val.url);
                this.checkRegionForSpeedLink(val.region);
                this.setComputeRegionDetails(val.region);
                this.setState({ regionList: data });
            } else {
                this.setState({ isAction: false });
            }
        });
    }

    setComputeRegionDetails(regionName) {
        instanceService.getRegionListByType('compute').then(data1 => {
            let data = data1;
            this.setState({ isAction: false });
            if(data && data.length > 0) {
                let val = data.find(item => item.region === regionName);
                this.setState({ computeRegionList: data, selectedRegionUrl: val.url });
            }
        });
    }

    getComputeRegionUrl(region) {
        return this.state.computeRegionList.find(elem => elem.region === region).url;
    }

    getImageRegionUrl(region) {
        return this.state.regionList.find(elem => elem.region === region).url;
    }

    setImageDetailsByRegion() {
        let form = this.state.instanceForm;
        let imageDistName = this.getImageVersion(this.props.location.state.instance.name);
        form.unitName = imageDistName;
        form.distName = imageDistName;
        form.name = imageDistName;
        this.setState({ instanceForm: form, distributeDisplay: 'none' });
    }

    setFlavorDetailsByRegion(regionName) {
        instanceService.getFlavorDetailsByRegion(regionName).then(flavors => {
            if(flavors !== undefined && Array.isArray(flavors)) {
                let sortedFlavours = this.sortPlanByAmount(flavors);
                this.setState({
                    instancePlans: flavors,
                    instanceFilterPlans: sortedFlavours.filter(filt => filt.type === 'SCPU')
                });
            }
        });
    }

    sortPlanByAmount(items) {
        if(items.length > 0) {
            items.sort(function (a, b) {
                return a.monthlyRate - b.monthlyRate;
            });
        }
        return items;
    }

    setSshKeyByRegion(regionUrl) {
        instanceService.getSshKeyByRegion(regionUrl).then(list => {
            this.setState({ sshKeys: list, isAction: false });
        });
    }

    setSshKeySelectByRegion(regionUrl, keyName) {
        instanceService.getSshKeyByRegion(regionUrl).then(list => {
            let ob = list.find(item => item.name === keyName);
            let sshKeysLoc = this.state.sshKeys;
            let sshAuthorizedKeys = this.state.sshAuthorizedKeys;
            ob.isSelected = true;
            sshKeysLoc.push(ob);
            sshAuthorizedKeys.push(ob);
            this.setState({ sshKeys: sshKeysLoc, isAction: false, sshAuthorizedKeys: sshAuthorizedKeys });
        });
    }

    planBoxClick = (event, param) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        $(event.currentTarget).toggleClass('active');
        let form = this.state.instanceForm;
        form.ram = param.ram;
        form.processor = param.processor;
        form.storage = param.storage;
        form.flavorRefId = param.id;
        form.flavorType = param.type;
        form.monthlyRate = param.monthlyRate;
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, param.type, param.ram);
        }
        this.isDisabled();
        this.setState({ instanceForm: form, errorMessg: '', selectedFlavor: param, planErrorMessg: '' });
    };

    planRadioClick = (event, type) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let form = this.state.instanceForm;
        form.unit = 1;
        form.ram = '';
        form.processor = '';
        form.storage = '';
        form.flavorRefId = '';
        form.flavorType = '';
        form.monthlyRate = '';
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, '', '');
        }
        this.isDisabled();
        this.setState({ isScpu: true, isYearly: false, isPrepaidMonthly: true });
    };
    onDscpuPlanClick = (event, type) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let plans = this.state.instancePlans.filter(item => item.type !== 'SCPU');
        let form = this.state.instanceForm;
        form.unit = 1;
        form.ram = '';
        form.processor = '';
        form.storage = '';
        form.flavorRefId = '';
        form.flavorType = '';
        form.monthlyRate = '';
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, '', '');
        }
        this.isDisabled();
        this.setState({ dcpuList: plans, isScpu: false, isYearly: false, isPrepaidMonthly: true });
    };

    closeBlockUserPopup = () => {
        $(".blockUser_popup").removeClass('active');
        $("body").removeClass("no_scroll");
    };


    handlesubmit = (event) => {
        event.preventDefault();
        let isSshKey = this.state.isSshKey;
        if(this.state.isBlocked) {
            $(".blockUser_popup").addClass('active');
            $("body").addClass("no_scroll");
            return;
        }
        if(!this.validate()) {
            return;
        }
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectToCCPage: true
            });
            return;
        }
        if(localStorage.getItem("status") === 'S') {
            this.setState({
                message: i18n.t('inst_clone_suspended_failure'),
                msgType: "error",
            });
            return;
        }
        if(this.state.isCreateExternalDisabled) {
            this.setState({
                message: i18n.t('ext_creation_disabled'),
                msgType: "error"
            });
            return;
        }
        let form = this.state.instanceForm;
        form.unitName = this.state.instanceForm.unitName.trim();
        this.setState({ isAction: true, instanceForm: form });
        let snapReqBody = {
            createImage: {
                name: removeSpecialCharacter(this.props.location.state.instance.name) + '-' + dateInUTC()
            }
        };
        let requestBody = {
            server: {
                flavorRef: this.state.instanceForm.flavorRefId,
                imageRef: this.state.instanceForm.imageRefId,
                key_name: this.state.keyName,
                max_count: this.state.instanceForm.unit,
                min_count: 1,
                name: form.unitName
            },
            name: getDistUserName(this.state.instanceForm.distName.toLowerCase()),
            //sshAuthorizedKeys: isSshKey ? this.getSShList(this.state.sshAuthorizedKeys) : [],
            //passwords: isSshKey ? null : this.state.instanceForm.password,
            backupEnabled: this.state.instanceForm.isBackupEnabled,
            privateIp: this.state.instanceForm.privateIp,
            userData: form.isUserData ? this.state.instanceForm.userData : 'cloning',
            regionName: this.state.instanceForm.region,
            distrName: this.state.instanceForm.distrVersionName,
            rootLogin: this.state.instanceForm.isLoginData,
            yearly: this.state.isYearly,
            discCode: this.state.isPrepaidMonthly ? this.state.promocode : this.state.discCode,
            toImageRegionUrl: this.getImageRegionUrl(this.state.instanceForm.region),
            fromImageRegionUrl: this.getImageRegionUrl(this.props.location.state.instance.region),
            fromComputeRegionUrl: this.getComputeRegionUrl(this.props.location.state.instance.region),
            instanceId: this.props.location.state.instance.id,
            snapReqBody: snapReqBody,
            fromRegionName: this.props.location.state.instance.region,
            isCloud: true,
            srcInstName: this.props.location.state.instance.name,
            prepaidMonthly: this.state.isPrepaidMonthly
        };
        let regionUrl = this.state.selectedRegionUrl;
        if(regionUrl === '') {
            regionUrl = this.getComputeRegionUrl(this.state.instanceForm.region);
        }

        instanceService.createCloneServer(JSON.stringify(requestBody), regionUrl).then(resp => {
            if(resp && resp === "BLOCKED") {
                this.setState({
                    userBlockType: "instance",
                    isAction: false
                });
                $(".blockUser_popup").addClass('active');
                $("body").addClass("no_scroll");
                return;
            }
            if(resp && (resp.server || resp.reservation_id)) {
                let plan_type = this.state.isPrepaidMonthly ? 'Prepaid monthly ' : this.state.isYearly ? 'Prepaid yearly ' : 'Postpaid monthly ';

                let instanceCreateName = plan_type + "instance clone request for " + requestBody.server.name + " has been initiated from region " + requestBody.fromRegionName + "to region " + requestBody.regionName;

                if(this.state.instanceForm.isBackupEnabled) {
                    localStorage.setItem("_banner_show", "hide");
                    instanceCreateName = instanceCreateName + " with backup enabled";
                }
                if(this.state.instanceForm.privateIp) {
                    instanceCreateName = instanceCreateName + " with private IP";
                }
                if(this.state.instanceForm.isBackupEnabled && this.state.instanceForm.privateIp) {
                    instanceCreateName = instanceCreateName + " with backup enabled and private IP";
                }
                if(!this.state.instanceForm.isBackupEnabled) {
                    localStorage.setItem("_banner_show", "show");
                }
                const requestBdy = {
                    "userId": localStorage.getItem("userId"),
                    "name": instanceCreateName,
                    "operation": "Instance clone requested",
                    "region": this.state.instanceForm.region
                };
                AuditLog.storeAuditLogs(requestBdy, "instance").then((resp) => {
                    if(resp === false);
                });
                localStorage.setItem("cloneMsg", "Cloning operation is in progress. It may take some time to complete depending upon the size of the image.");
                if(this.state.isYearly && this.state.instanceForm.unit > 1) {
                    let timewait = (this.state.instanceForm.unit * 1000) / 2;
                    setTimeout(() => {
                        this.navigateToIndex();
                    }, timewait);
                } else {
                    this.navigateToIndex();
                }
                return;
            }
            if(resp && resp.message.includes("403")) {
                this.setState({ message: 'Forbidden Access', msgType: 'error', isAction: false });
                window.scrollTo(0, 0);
                return;
            }
            if(resp && resp.badRequest === undefined) {
                this.setState({ message: resp.message, msgType: 'error', isAction: false });
                return;
            }
            if(resp === undefined || resp.badRequest === undefined) {
                this.setState({ message: 'Internal network issue. Please try again.', msgType: 'error', isAction: false });
                return;
            }
            console.log(resp.badRequest.message);
            this.setState({ message: 'Failed to create the Instance', msgType: 'error', isAction: false });
        });
    };
    constructUnitName(distName, version, flavorType, ram) {
        if(this.state.isUnitNameFocused) {
            return;
        }
        if(version) {
            version = version.replace('.', '-');
        } else {
            version = '';
        }
        let newName = distName + version + '-' + flavorType + '-' + ram + '-' + this.state.instanceForm.region + '-clone';
        if(this.state.instanceForm.unit === 1) {
            newName = newName + '-1';
        }
        if(newName === undefined) {
            return newName;
        }
        return newName.split(' ').join('');
    }
    getSShList(list) {
        let newList = [];
        list.forEach(item => {
            newList.push(item.public_key);
        });
        return newList;
    }
    isDisabled() {
        //if(this.state.isScpu===false || this.state.instanceForm.imageRefId==='' || this.state.instanceForm.flavorRefId===''){
        if(this.state.instanceForm.flavorRefId === '') {

            this.setState({ isCreateDisabled: true });
            return;
        }
        this.setState({ isCreateDisabled: false });
    }
    validate() {
        var nameRegex = new RegExp("^[-a-zA-Z0-9]*$");
        let flavors = this.props.location.state.flavors;
        let flavorStorage = flavors.storage.replace('GB', '').trim();
        // if(!this.state.isScpu){
        //     this.setState({errorMessg:'You cannot create instance using Dedicated cpu flavour'});
        //     window.scrollTo(0, 0);
        //     return false
        // }
        if(this.state.instanceForm.region === '') {
            this.setState({ regionErrorMsg: 'Please select a region' });
            window.scrollTo(0, 0);
            return false;
        }

        if(this.state.instanceForm.flavorRefId === '') {
            document.getElementById('distribute_sec').scrollIntoView(true);
            return false;
        }
        let flavorSize = parseInt(this.state.selectedFlavor.storage.replace('GB', ''));
        if(flavorStorage > flavorSize) {
            this.setState({ planErrorMessg: 'Select a plan with disk storage equal or greater than the current disk storage required for the selected instance.' });
            document.getElementById('distribute_sec').scrollIntoView(true);
            return false;
        }

        if(this.state.instanceForm.unit === undefined || this.state.instanceForm.unit === '') {
            document.getElementById('final_create_sec').scrollIntoView(true);
            document.getElementById('unitbox').focus();
            this.setState({ unitErrorMessg: 'Minimum 1 unit is required.' });
            return false;
        }
        if(this.state.instanceForm.unitName === undefined || this.state.instanceForm.unitName.trim() === '') {
            document.getElementById('final_create_sec').scrollIntoView(true);
            document.getElementById('unitName').focus();
            this.setState({ unitNameErrorMessg: 'Unit name is required.' });
            return false;
        }
        if(!nameRegex.test(this.state.instanceForm.unitName)) {
            document.getElementById('final_create_sec').scrollIntoView(true);
            document.getElementById('unitName').focus();
            this.setState({ unitNameErrorMessg: 'Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)' });
            return false;
        }
        if(!this.state.isUserSubscribed) {
            if(!isCountLessthanThreshold(this.state.instanceForm.region, this.state.instanceForm.unit)) {
                this.setState({ maxInstErrorMessg: true });
                window.scrollTo(0, 0);
                return false;
            }
        }

        this.setState({ errorMessg: '' });
        return true;
    }

    onImageClick = (event, elem) => {
        $('.create_module .distribute_sec .distribution_box').removeClass('active');
        let form = this.state.instanceForm;
        let imageList = this.state.images;
        imageList.forEach(item => {
            item.isSelected = false;
        });
        elem.isSelected = true;
        form.imageRefId = elem.id;
        let imageDistName = this.getImageVersion(elem.name);
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(imageDistName, '', this.state.instanceForm.flavorType, this.state.instanceForm.ram);
        }
        form.distName = imageDistName;
        form.name = imageDistName;

        let uniqueDistImages = this.state.uniqueDistImages;
        for(var i = 0; i < uniqueDistImages.length; i++) {
            uniqueDistImages[i].selectedVersion = undefined;
        }
        this.setState({ instanceForm: form, images: imageList, selectedImage: elem, uniqueDistImages: uniqueDistImages, distErrorMessg: '' });
        $(event.currentTarget).addClass('active');
        this.isDisabled();
    };

    onsshSelect = (event, elem) => {
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        let list = this.state.sshAuthorizedKeys;
        let sshKeysLoc = this.state.sshKeys;
        if(val) {
            list.push(elem);
            elem.isSelected = true;
            sshKeysLoc.forEach(item => {
                if(item.name === elem.name) {
                    item.isSelected = true;
                }
            });
            this.setState({ keyName: elem.name });
        } else {
            elem.isSelected = false;
            sshKeysLoc.forEach(item => {
                if(item.name === elem.name) {
                    item.isSelected = false;
                }
            });
            list = list.filter(item => item.name !== elem.name);
        }
        this.setState({ sshAuthorizedKeys: list, sshErrorMessg: '', sshKeys: sshKeysLoc });
    };

    unitKeyDown(e) {
        if(e.keyCode === 39 || e.keyCode === 38) {
            this.addUnit();
        }
        if(e.keyCode === 37 || e.keyCode === 40) {
            this.removeUnit();
        }
    }
    navigateToImage() {
        this.props.history.push({
            pathname: '/images',
            state: {
                imagetype: "custom"
            }
        });
    }
    navigateToIndex() {
        this.props.history.push({
            pathname: "/index",
            state: {
                val: 'server created'
            }
        });
    }
    getRegionDropdown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        $(".scrollarea-content").removeAttr("tabindex");
        if(this.props.location.state && this.props.location.state.image && this.props.location.state.regionName) {
            return;
        }
        $(".regionSelect_options").addClass("active");
        $(".region_select_container").addClass("active");
        document.getElementById('regionId').focus();
        let form = this.state.instanceForm;
        this.setState({ regionListFilter: this.state.regions, isregionselected: false, instanceForm: form, dropRegion: '' }, () => this.scrollTop());
    };
    getSelectedRegion = (event, regionOb) => {

        let id = regionOb.id; let region = regionOb.name; let countryName = regionOb.countryName.toLowerCase();
        let form = this.state.instanceForm;
        if(regionOb.status !== 1) {
            sessionStorage.inFocus = true;
            return;
        }
        sessionStorage.inFocus = false;
        $(".regionSelect_options").removeClass("active");

        $(".region_select_container").removeClass("active");
        if(id === form.region) {
            return;
        }
        if(!this.state.isUserSubscribed) {
            let item = this.state.regionList.find(elem => elem.region === id);
            form.regionUrl = item.url;
            form.region = id;
            form.regionValue = region;
            form.regionCapcity = regionOb.capacity;
            this.onRegionChange(id);
        }
        else {
            let item = this.state.regionList.find(elem => elem.region === id);
            form.region = id;
            form.regionValue = region;
            form.regionCapcity = regionOb.capacity;
        }

        this.setState({ countryName: countryName, errorMessg: '', instanceForm: form, regionErrorMsg: '', isregionselected: true, isCreateDisabled: true });
    };
    filterDropDown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        $(".scrollarea-content").removeAttr("tabindex");
        if(this.props.location.state && this.props.location.state.image && this.props.location.state.regionName) {
            return;
        }
        $(".regionSelect_options").addClass("active");
        let name = event.target.name;
        let val = event.target.value;
        let lcVal = val.toLowerCase();
        let items = this.state.regions.filter(item => item.id.toLowerCase().includes(lcVal) || item.name.toLowerCase().includes(lcVal));
        //let form = this.state.instanceForm
        //form.region = val

        this.setState({ regionListFilter: items, selectedRegionUrl: '', dropRegion: val });
    };
    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [] });
            }
            if(resp && resp.length > 0) {
                let form = this.state.instanceForm;
                let filtRegions = resp.filter(item => item.status === 1);
                //let newFiltRegions = filtRegions.filter(item => item.id!==this.props.location.state.instance.region)
                let elem = filtRegions.find(item => item.id === this.props.location.state.instance.region);
                if(elem === undefined && filtRegions.length > 0) {
                    elem = filtRegions[0];
                }
                if(elem !== undefined) {
                    form.region = elem.id;
                    form.regionValue = elem.name;
                    form.regionCapcity = elem.capacity;
                    this.setState({ regions: resp, isregionselected: true, countryName: elem.countryName });
                    this.setImageRegionDetails(elem.id);

                }
            } else {
                this.setState({ isAction: false });
            }

        });

    };
    onFocusOut = (e) => {
        if(!e.currentTarget.contains(e.relatedTarget)) {
            if(sessionStorage.inFocus === true) {
                sessionStorage.inFocus = false;
                return;
            }
            this.setState({ dropRegion: '', isregionselected: true });
            $(".regionSelect_options").removeClass('active');
            $(".region_select_container").removeClass("active");
        }
    };

    onDropArrowClick = () => {
        if($('.regionSelect_options').is('active')) {
            $(".regionSelect_options").addClass("active");
        } else {
            $(".regionSelect_options").removeClass('active');
        }
    };


    getImageVersion(name) {
        try {
            if(name === undefined) {
                return name;
            }
            name = name.split(' ').join('');
            if(name.includes('-')) {
                let nameArr = name.split('-');
                let firstPart = nameArr[0];
                if((firstPart.includes('open') || firstPart.includes('CentOS') || firstPart.includes('Ubuntu')) && nameArr.length >= 2) {
                    if(nameArr[1] && nameArr[1] !== '') {
                        nameArr = nameArr[0] + '-' + nameArr[1];
                    } else {
                        nameArr = firstPart;
                    }
                    return nameArr.split('.').join('-');
                } else if(firstPart.includes('Debian9') || firstPart.includes('Fedora')) {
                    return nameArr[0].split('.').join('-');
                }
            }
            if(name.length > 10) {
                return name.substring(0, 10);
            }
        } catch(err) {
            return name;
        }
        return name;
    }

    scrollTop() {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    }

    onDiffPlanClick = (planType) => {
        $('.create_module .planOption_sec .plan_box').removeClass('active');
        let form = this.state.instanceForm;
        form.ram = '';
        form.processor = '';
        form.storage = '';
        form.flavorRefId = '';
        form.flavorType = '';
        form.monthlyRate = '';
        form.unit = 1;
        if(!this.state.isUnitNameFocused) {
            form.unitName = this.constructUnitName(this.state.instanceForm.distName, this.state.instanceForm.version, '', '');
        }
        this.isDisabled();
        if(planType === 'yearly') {
            this.setState({ isYearly: true, isPrepaidMonthly: false, instanceForm: form });
        }
        else if(planType === "prepaidMonthly") {
            this.setState({ isYearly: false, isPrepaidMonthly: true, instanceForm: form });
        }
        else {
            this.setState({ isYearly: false, instanceForm: form, isPrepaidMonthly: false });
        }
    };
    setUnitName(unitCount) {
        if(!this.state.isUnitNameFocused) {
            let form = this.state.instanceForm;
            let name = form.unitName;
            if(name) {
                let endString = name.substring(name.length - 2, name.length);
                if(endString === '-1' && unitCount > 1) {
                    form.unitName = name.substring(0, name.length - 2);
                    this.setState({ instanceForm: form });
                }
                if(endString !== '-1' && unitCount === 1) {
                    form.unitName = name + '-1';
                    this.setState({ instanceForm: form });
                }
            }
        }
    }

    checkRegionForSpeedLink = (region) => {
        let flag = true;
        /*let regionList = ["TX2","TX3","LA2","BOS1","CO1","ATL1","NJ1","PDX1","PX1",
        "LA3",
        "MIA1",
        "NC1",
        "ORD1",
        "PA1",
        "SEA1",
        "SFO1",
        "TX1",
        "VA1","NYC1"];
        for(let i=0;i<regionList.length;i++){
            if(regionList[i] == region){
                flag = true
            }
        }*/
        if(flag) {
            this.setState({
                showSpeed: true,
                setLink: "https://speedtest-" + region + ".idrivecompute.com"
            });


        }
        else {
            this.setState({
                showSpeed: false,
                setLink: ""
            });
        }

    };
    redirectToSpeedTest = () => {
        let region = this.state.instanceForm.region.toLowerCase();

        let url = "https://speedtest-" + region + ".idrivecompute.com";
        window.open(url, "_blank");
    };

    render() {
        let plan_type = this.state.isPrepaidMonthly ? 'Prepaid Monthly' : this.state.isYearly ? 'Prepaid Yearly' : 'Postpaid Monthly';

        if(this.state.isRedirectToCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        const { classes } = this.props;

        const backupCss = `
         .stb{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;
        const customCss = `
         .st0{display:none;}
         .st1{display:inline;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
         .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;

        const snapCss = `
        .sts{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        `;
        let instance, flavors;
        if(this.props.location?.state?.instance && this.props.location?.state?.flavors) {
            instance = this.props.location.state.instance;
            flavors = this.props.location.state.flavors;
        } else {
            return <Redirect to={ '/index' } replace={ true }></Redirect>;
        }
        return (
            <div className="create_module" >
                <main >
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={ 'instances' }></LeftNav>
                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ false } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="title_txt">
                                            {/*<span className="text bold_600">Create&nbsp;-&nbsp;</span>*/ }
                                            <span className="title_info">Create a clone from an existing instance</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <section className="main_section">
                            <div className="main_body_container">
                                <div className="createModule_wrapper" >
                                    <section className="dataCenter_sec" >
                                        <div className="custom_tabs_wrap">
                                            <div className="infobox">
                                                <p>The cloned instance will be created with the same password and SSH Keys (if any) as the original instance</p>
                                            </div>
                                        </div>
                                        <span className="error_msg create_err_msg" style={ { display: this.state.maxInstErrorMessg ? 'block' : 'none' } }>You can create up to 25 instances in a region. If you need to create more instances,<a href="https://www.idrivecompute.com/support.htm" target="_blank"> Contact support</a></span>
                                        <span id="errorMessg" className="error_msg create_err_msg" style={ { display: this.state.errorMessg ? 'block' : 'none' } }>{ this.state.errorMessg }</span>
                                        <h3>Select a Region</h3>
                                        <p className="h3_title_txt" style={ { display: "none" } }>Select a region nearest to your current location. </p>
                                        <span className="error_msg create_err_msg">{ this.state.regionErrorMsg }</span>
                                        <div className="inp_row no_label">

                                            <div className="common_txtBox_row region_select" onBlur={ (e) => this.onFocusOut(e) }>
                                                <label style={ { display: "none" } }>Regions</label>
                                                <div className="region_select_container" >
                                                    <div className="slectBox" onClick={ (e) => this.getRegionDropdown(e) } >
                                                        <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                            <textarea id="regionId" name="region" value={ this.state.dropRegion } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="off"></textarea>
                                                        </div>
                                                        <ul>
                                                            <li className="selected_elem"><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.instanceForm.regionValue } ({ this.state.instanceForm.region })
                                                                <span class={ Number(this.state.instanceForm.regionCapcity) < 20 ? "vcpu_value limited" : "vcpu_value available" }>{ this.state.instanceForm.regionCapcity }%<i></i> { Number(this.state.instanceForm.regionCapcity) < 20 ? "Limited Capacity" : "Capacity Available" }</span>
                                                            </li>
                                                        </ul>
                                                        <span className="dropArrow" > <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                            <title>drop-down</title>
                                                            <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                        </svg>
                                                        </span>
                                                        <span class="vcpu_label">Capacity Available</span>
                                                    </div>

                                                    <div className="regionSelect_options" style={ { maxHeight: "inherit", overflowY: "inherit" } }>
                                                        <ScrollArea ref={ this.scrollRef }
                                                            speed={ 0.8 }
                                                            style={ { maxHeight: "245px" } }
                                                            vertical={ true }
                                                            horizontal={ false }
                                                            minScrollSize={ 10 }
                                                            smoothScrolling={ true }
                                                            verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1", } }
                                                            verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                            stopScrollPropagation={ true }


                                                        >

                                                            { this.state.regionListFilter.length <= 0 ?

                                                                <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 && !this.state.isregionselected ? "" : "none" } }>
                                                                    <li>No matching region found</li>
                                                                </ul>

                                                                :

                                                                <ul>

                                                                    { this.state.regionListFilter.map((region, i) =>
                                                                        <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })
                                                                            <span style={ { display: region.status != 1 ? "none" : "" } } class={ Number(region.capacity) < 20 ? "vcpu_value limited" : "vcpu_value available" }>{ region.capacity }%<i></i> { Number(region.capacity) < 20 ? "Limited Capacity" : "Capacity Available" }</span>
                                                                            <span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                        </li>
                                                                    ) }

                                                                </ul>
                                                            }
                                                        </ScrollArea>
                                                    </div>

                                                </div>
                                            </div>
                                            <a href={ this.state.setLink } class="speedTest_link" style={ { display: this.state.showSpeed ? "" : "none" } } target="_blank" >Perform Network Speed Test for this Region</a>
                                            <a data-tip data-for="speedlink" href={ this.state.setLink } class="speedTest_link speedTest_btn" style={ { display: this.state.showSpeed ? "" : "none" } } target="_blank">Perform Network Speed Test for this Region</a>
                                            <ReactTooltip id="speedlink" place="top" effect='solid'>Perform Network Speed Test for this Region</ReactTooltip>
                                        </div>
                                        {/*<p class="note_txt region_note"><strong>Note: </strong>The overall performance of the instances depend on the capacity available at the selected region.</p>*/ }
                                    </section>

                                    <section className="distribute_sec" id="distribute_sec">
                                        <div className="custom_tabs_wrap">
                                            {/* <div className="infobox">
                                                <p>The cloned instance will be created with the same password and SSH Keys (if any) as the original instance</p>
                                            </div> */}
                                            <ul>
                                                <li className="newDistribute_tab active">Instance selected to clone</li>

                                            </ul>
                                        </div>
                                        <div className="distribute_box_container clearfix">

                                            <div className="dist_box_wrap newDistribute active">
                                                <div className="distribution_box active" style={ { width: '480px' } }>
                                                    <div className="os_Img">
                                                        <div className="server_icon">
                                                            <div className="icon_img">
                                                                <span className="icon">
                                                                    <svg x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" style={ { enableBackground: 'new 0 0 100 100' } } xmlSpace="preserve">
                                                                        <path fill="#FFFFFF" d="M73.6,26.7c0,0,4.8,3.5,1.8,9.4l-2.8,5.3l-16.4-9.3c0,0-2.8-1.4-5.4,0.1l-13,7c0,0-2.3,0.8-2.3,2.9v14.5
		                                                                                    c0,0-0.6,2.4,1.6,3.5l14,8.3c0,0,2.6,1.6,5.5-0.2l15.2-9.8l2.8,3.7c0,0,4.5,6-1.1,10.8l-16,9.9c0,0-3,2.2-7.2-0.2L26.6,69.1
		                                                                                    c0,0-3.5-1.3-3-5.8V36.1c0,0-0.5-3,2-5l23.8-13.5c0,0,4.1-2.4,7-0.7L73.6,26.7z"></path>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="os_desc">
                                                        <div className="desc_wrap">
                                                            <div className="dist_name text_elipses"> { instance.name } </div>
                                                            <div className="dist_version">{ flavors.type + ', ' + flavors.processor + flavors.processorType + flavors.ram + ' RAM, ' + flavors.storage + ' NVMe storage' }</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>


                                    <section className="planOption_sec" id="planOption_sec">
                                        <h3>Choose a plan</h3>
                                        <p className="h3_title_txt" style={ { display: this.state.isScpu ? 'block' : 'none' } }>Shared CPU instances support medium workloads with balanced resource utilization</p>
                                        <p className="h3_title_txt" style={ { display: this.state.isScpu ? 'none' : 'block' } }>Dedicated CPU instances are ideal to handle heavy workloads with optimum performance</p>
                                        <span className="error_msg create_err_msg" style={ { display: this.state.planErrorMessg ? 'block' : 'none' } } >{ this.state.planErrorMessg }</span>
                                        <div className="customPlans_radio_wrap">
                                            <label className={ this.state.isScpu ? "custom_radio active" : "custom_radio" } onClick={ (e) => this.planRadioClick(e, 'SCPU') }>Shared CPU
                                                <input type="radio" defaultChecked="checked" name="customPlan_options" />
                                                <span className="checkmark"></span>
                                            </label>
                                            <label className={ !this.state.isScpu ? "custom_radio active" : "custom_radio " } onClick={ (e) => this.onDscpuPlanClick(e, 'DCPU') }>Dedicated CPU
                                                <input type="radio" name="customPlan_options" />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="plan_scpu" style={ { display: this.state.isScpu ? 'block' : 'none' } }>
                                            <div className="plan_container" >
                                                <ul className="scpu_tabs">
                                                    <li class={ this.state.isPrepaidMonthly ? "active" : "" } data-tabs="SCPU-prepaid-monthly" onClick={ () => this.onDiffPlanClick('prepaidMonthly') }>
                                                        <p class="text">Prepaid Monthly</p>
                                                    </li>
                                                    <li data-tabs="SCPU-monthly" className={ this.state.isYearly || this.state.isPrepaidMonthly ? "" : "active" } onClick={ () => this.onDiffPlanClick('monthly') }><p className="text">Postpaid Monthly</p></li>
                                                    <li className={ this.state.isYearly ? "active" : "" } data-tabs="SCPU-yearly" onClick={ () => this.onDiffPlanClick('yearly') }><p className="text">Prepaid Yearly</p></li>

                                                </ul>
                                                <div className={ this.state.isYearly ? "scpu_yearly_plan show" : "scpu_monthly_plan show" }>
                                                    <div className="scpu_offerBlk no-bg">
                                                        { this.state.isYearly &&
                                                            <div className="offer-text-blk">
                                                                <p className="saveoffer-txt"><span className="red-hht-txt">{ this.state.discPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                                <p className="subscribe-txt">Subscribe to prepaid yearly plans and get discounts</p>
                                                            </div> }
                                                        { this.state.isPrepaidMonthly &&
                                                            <div className="offer-text-blk">
                                                                <p className="saveoffer-txt"><span className="red-hht-txt">{ this.state.discMonPerce }%<sup>*</sup></span> OFF for the first year</p>
                                                                <p className="subscribe-txt">Subscribe to prepaid monthly plans and get discounts</p>
                                                            </div> }
                                                        { !this.state.isYearly && !this.state.isPrepaidMonthly &&
                                                            <div className="offer-text-blk">
                                                                <p className="monthly-paytxt">Pay as you use with monthly postpaid plans</p>
                                                            </div>
                                                        }
                                                    </div>
                                                    { this
                                                        .state
                                                        .instanceFilterPlans
                                                        .map((instancePlan, i) => <div className="plan_box" key={ i } onClick={ (e) => this.planBoxClick(e, instancePlan) }>
                                                            { this.state.isYearly ?
                                                                <div className="cost_details">
                                                                    <div className="cost_option2 actual_cost">
                                                                        <span className="strike_thru">$ { instancePlan.monthlyRate * 12 }</span><span className="cost-sub">/year</span>
                                                                    </div>
                                                                    <div className="cost_option1">$ { instancePlan.monthlyRate * 12 - (instancePlan.monthlyRate * 12) / this.state.discVal }<span className="cost-sub">/first year</span></div>
                                                                </div> :
                                                                this.state.isPrepaidMonthly ?
                                                                    <div className="cost_details">
                                                                        <div className="cost_option2 actual_cost">
                                                                            <span className="strike_thru">$ { instancePlan.monthlyRate }</span><span className="cost-sub">/month</span>
                                                                        </div>
                                                                        <div className="cost_option1">$ { instancePlan.monthlyRate - (instancePlan.monthlyRate) / this.state.discMonVal }<span className="cost-sub">/month</span></div>
                                                                    </div> :
                                                                    <div className="cost_details">

                                                                        <div className="cost_option1">$ { instancePlan.monthlyRate }<span className="cost-sub">/month</span>
                                                                        </div>
                                                                        <div className="cost_option2">${ instancePlan.hourlyRate }/hour</div>
                                                                    </div> }
                                                            <div className="plan_details">
                                                                <ul className="detail_info">
                                                                    <li>
                                                                        <div className="col1">RAM</div>
                                                                        <div className="col2">{ instancePlan.ram }</div>
                                                                    </li>
                                                                    <li>
                                                                        <div className="col1">Processor</div>
                                                                        <div className="col2">{ instancePlan.processor }</div>
                                                                    </li>
                                                                    <li>
                                                                        <div className="col1">NVMe Storage</div>
                                                                        <div className="col2">{ instancePlan.storage }</div>
                                                                    </li>
                                                                    <li>
                                                                        <div className="col1">Bandwidth</div>
                                                                        <div className="col2">{ formatBandwidthBytes(instancePlan.bandwidth, this.state.isYearly) }</div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>)
                                                    }
                                                    { this.state.isYearly && <p className="offer_note" >
                                                        <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                                        <br></br>- The { this.state.discPerce }% offer on yearly instances is applicable for the first year only. For subsequent years, normal charges are applicable.
                                                        <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                                        <span style={ { display: this.state.isBmr ? "none" : "" } }><br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.</span>
                                                    </p> }
                                                    { this.state.isPrepaidMonthly && <p className="offer_note" >
                                                        <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                                        <br></br>- The { this.state.discMonPerce }% offer on yearly instances is applicable for the first year only. For subsequent years, normal charges are applicable.
                                                        <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                                        <span style={ { display: this.state.isBmr ? "none" : "" } }><br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.</span>
                                                    </p> }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="plan_container" style={ { display: !this.state.isScpu ? 'block' : 'none' } }>
                                            <DedicatedCpu dcpuList={ this.state.dcpuList } planBoxClick={ (e, param) => this.planBoxClick(e, param) } isPrepaidMonthly={ this.state.isPrepaidMonthly }
                                                isYearly={ this.state.isYearly } onDiffPlanClick={ (type) => this.onDiffPlanClick(type) } discMonPerce={ this.state.discMonPerce } discMonVal={ this.state.discMonVal }
                                                discPerce={ this.state.discPerce } discVal={ this.state.discVal } setYearly={ () => this.setState({ isYearly: false, isPrepaidMonthly: true }) } />
                                        </div>
                                    </section>

                                    <section className="final_create_sec" id="final_create_sec">
                                        <h3>Finalize and Create</h3>
                                        <div className="finalCreate_col finalInstance">
                                            <div className="col1" style={ { display: this.state.isYearly || this.state.isPrepaidMonthly ? 'none' : '' } }>
                                                <label className="txtBox_label">Number of instance</label>
                                                <span className="label_info">Multiple instances can be created with the same configuration</span>
                                                <div className="unit_box add_remove_field" >
                                                    <span className="sub_icon" onClick={ this.removeUnit }>
                                                        <span className="icon"></span>
                                                    </span>
                                                    <input type="text" id="unitbox" name="unit" value={ this.state.instanceForm.unit + " Unit" } onChange={ this.formChangeHandler } disabled={ this.state.isYearly } />

                                                    <span className="add_icon" onClick={ this.addUnit }>
                                                        <span className="icon"></span>
                                                    </span>
                                                </div>
                                                <span className="comm_error_msg" >{ this.state.unitErrorMessg }</span>
                                            </div>
                                            <div className="col2" style={ { marginLeft: this.state.isYearly ? '0' : '' } }>
                                                <label className="txtBox_label ">Name</label>
                                                <span className="label_info"> Unit name can contain alphanumeric characters (a-z, A-Z, 0-9) and dashes (-)</span>
                                                <div className="unit_box">
                                                    <input id="unitName" placeholder="Provide a name for the instance" autoComplete="off"
                                                        type="text"
                                                        name="unitName"
                                                        value={ this.state.instanceForm.unitName }
                                                        onChange={ this.formChangeHandler }
                                                        onFocus={ () => this.state.isUnitNameFocused ? null : this.setState({ isUnitNameFocused: true }) }
                                                    /></div>
                                                <span className="comm_error_msg" >{ this.state.unitNameErrorMessg }</span>
                                            </div>
                                        </div>
                                        <p className="unit-note" style={ { display: this.state.instanceForm.unit > 1 ? '' : 'none' } }>You are adding multiple instances with the same configuration. For easy identification, the instance names will be suffixed with a number. E.g., { this.state.instanceForm.unitName }-1, { this.state.instanceForm.unitName }-2, { this.state.instanceForm.unitName }-3 etc.</p>
                                    </section>

                                    <section className="optional_addOn_sec enable_bkp">
                                        <h3>Optional Add-ons</h3>
                                        <div className="addOn_list_wrap">
                                            <ul>
                                                <li>
                                                    <div className="addOn_container">
                                                        <label className="checkBox">
                                                            <input type="checkbox" name="isBackupEnabled" checked={ this.state.instanceForm.isBackupEnabled } value={ this.state.instanceForm.isBackupEnabled } onChange={ this.formChangeHandler } />
                                                            <span className="checkmark"></span>
                                                            <p class="add_on_head"><strong>Enable Instance Backup:</strong> Protect your data and recover quickly in an emergency. <span class="usr_recomend">RECOMMENDED</span></p>
                                                        </label>
                                                        <p className="add_on_info">A system image backup of the instance will be performed on a daily basis. An additional amount of <strong>$0.05/GB</strong> will be charged per month.</p>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="addOn_container">
                                                        <label className="checkBox">
                                                            <input type="checkbox" name="privateIp" value={ this.state.instanceForm.privateIp } onChange={ this.formChangeHandler } />
                                                            <span className="checkmark"></span>
                                                            <p className="add_on_head">Private IP</p>
                                                        </label>
                                                        <p className="add_on_info">Add a private IP address to the instance to have a secure private communication with other instances within your account</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </section>

                                    <input disabled={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled }
                                        type="submit"
                                        name=""
                                        value="Create"
                                        className={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled ? "common_cta_btn blue create_vm_btn disabled" : "common_cta_btn create_vm_btn blue" }
                                        onClick={ this.handlesubmit }
                                    />
                                </div>
                            </div>
                            <div className="unit_summary_rhs">
                                <div className="head_block">Instance Summary</div>
                                <div className="summary_list">
                                    <ul>
                                        <li>
                                            <h4>Region</h4>
                                            { this.state.instanceForm.region ? <div className="summary_info">{ this.state.instanceForm.regionValue } ({ this.state.instanceForm.region })
                                            </div> : null
                                            }
                                        </li>
                                        <li>
                                            <h4>Version</h4>
                                            { this.state.instanceForm.distName ? <div className="summary_info">{ this.state.instanceForm.name }</div> : null }
                                        </li>
                                        <li>
                                            <h4>Plan</h4>
                                            { this.state.instanceForm.ram ? <div className="summary_info">{ this.state.instanceForm.processor }, { this.state.instanceForm.storage } NVMe Storage, { this.state.instanceForm.ram } RAM, { plan_type }</div> : null }
                                        </li>
                                        <li>
                                            <h4>Name</h4>
                                            <div className="summary_info">{ this.state.instanceForm.unitName }</div>
                                        </li>
                                        <li>
                                            <h4>Units</h4>
                                            <div className="summary_info">{ this.state.instanceForm.unit }</div>
                                        </li>
                                        { this.state.instanceForm.isBackupEnabled ?
                                            <li >
                                                <h4>Daily backup enabled*</h4>
                                            </li> : null
                                        }
                                    </ul>
                                    { this.state.isYearly && this.state.instanceForm.ram &&
                                        <div className="ic_total_amt_stke"><span>${ this.state.instanceForm.unit * 12 * this.state.instanceForm.monthlyRate }.00</span>/year</div>
                                    }

                                    { this.state.isPrepaidMonthly && this.state.instanceForm.ram &&
                                        <div className="ic_total_amt_stke"><span>${ this.state.instanceForm.unit * this.state.instanceForm.monthlyRate }</span>/month</div>
                                    }

                                    { this.state.isYearly ?
                                        <div className="total_amt">
                                            ${ this.state.instanceForm.unit * (this.state.instanceForm.monthlyRate * 12 - (this.state.instanceForm.monthlyRate * 12) / this.state.discVal) }.00/first year
                                        </div>
                                        :
                                        this.state.isPrepaidMonthly ?
                                            <div className="total_amt">
                                                ${ this.state.instanceForm.unit * (this.state.instanceForm.monthlyRate - (this.state.instanceForm.monthlyRate) / this.state.discMonVal) }/month
                                            </div> :
                                            <div className="total_amt">
                                                ${ this.state.instanceForm.unit * this.state.instanceForm.monthlyRate }.00/month
                                            </div>
                                    }

                                    { this.state.instanceForm.isBackupEnabled ?
                                        <div style={ { paddingLeft: '20px' } }>*Backups will incur an additional charge</div> : null
                                    }
                                    <input disabled={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled }
                                        type="button"
                                        name=""
                                        value="Create"
                                        className={ this.state.isCreateDisabled || this.state.isCreateExternalDisabled ? "common_cta_btn blue create_vm_btn disabled" : "common_cta_btn create_vm_btn blue" }
                                        onClick={ this.handlesubmit } />
                                </div>
                            </div>
                        </section>

                    </div>
                </main>
                {/*block User*/ }
                <div className="main_popup blockUser_popup ">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => this.closeBlockUserPopup() }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Unable to Create Instance</div>
                                </div>
                                <div className="popup_body">
                                    <p>Your instance could not be created. <a target="_blank" href=" https://www.idrivecompute.com/support.htm">Contact support</a> for further assistance.</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn blue" onClick={ () => this.closeBlockUserPopup() }>OK</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End of block user */ }
                <CommonMessage message={ this.state.message } isUserSubscribed={ this.state.isUserSubscribed } msgType={ this.state.msgType } handler={ () => this.setState({ message: '' }) } />
            </div>
        );
    }
}


function getPsswdStrength(psswd) {
    // const strongPwd = new RegExp("^(?=.*[a-z])(?=(.*[A-Z]){2})(?=.*[0-9])(?=.*[=+-_!@#\$%\^&\*])(?=.{8,})([a-zA-Z])+$");
    //const mediumPwd = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
    var str = psswd;
    var patt1 = new RegExp("^(?=.*[a-z])(?=(.*[A-Z]))(?=.*[0-9])(?=.*[-_!@#\$%\^&\*])(?=.{6,})"); //middle 6 charecters
    var charRegEx = new RegExp("^[a-zA-z0-9]"); // 
    var charRegEx1 = new RegExp("^[a-zA-z]");
    var str2 = str.slice(1, -1);
    var char1 = str.charAt(0); // uppercase or number
    var char2 = str.charAt(str.length - 1);

    var result = charRegEx.test(char1) && patt1.test(str2) && charRegEx1.test(char2);

    if(result) {
        return "Strong";
    }
    // if(mediumPwd.test(psswd)){
    //     return "Average"
    // }
    return "Weak";
}


function getBytes(val) {
    var size = "";
    if(val.includes('MB')) {
        size = val.replace('MB', '').trim();
        return size * 1024 * 1024;
    }
    if(val.includes('GB')) {
        size = val.replace('GB', '').trim();
        return size * 1024 * 1024 * 1024;
    }
    if(val.includes('TB')) {
        size = val.replace('TB', '').trim();
        return size * 1024 * 1024 * 1024 * 1024;
    }
    if(val.includes('PB')) {
        size = val.replace('PB', '').trim();
        return size * 1024 * 1024 * 1024 * 1024 * 1024;
    }
}

function getDistUserName(type) {
    let user = type;
    if(type === undefined || type === '') {
        return;
    }
    for(let i = 0; i < distributionOption.length; i++) {
        let item = distributionOption[i];
        if(type.includes(item.type)) {
            user = item.user;
            break;
        }
    }
    return user;
}

function isCountLessthanThreshold(regionName, currentCount) {
    let instCountList = JSON.parse(localStorage.getItem('instCountList'));
    if(instCountList !== null && instCountList !== undefined) {
        let ob = instCountList.find(item => regionName === item.key);
        if(ob !== undefined) {
            let newCount = ob.count + currentCount;
            if(newCount > 25) {
                return false;
            }
        }
    }
    return true;
}



export default withStyles(styles)(CloneInstance);